import * as z from 'zod';

import { fileQuerySchema } from '@/_schemas/file';

import { governanceQuerySchema } from './governance-query-schema';

export const governanceFormSchema = governanceQuerySchema.extend({
  jurisdiction: z.string(),
  registration_number: z.string(),
  registered_agent_name: z.string(),
  notes: z.string(),
  supporting_documentation: z.array(fileQuerySchema),
});

export type GovernanceFormSchema = z.infer<typeof governanceFormSchema>;
